import styled from 'styled-components';

import { getImagePath } from '../../../../Util/pathUtils';
import CourseContainer from '../CourseContainer';

const BackgroundImage = styled(CourseContainer)`
  background-image: ${({ $backgroundImage }) =>
    $backgroundImage !== '' ? `url(${getImagePath($backgroundImage)})` : 'none'};
  background-position: top center;
  background-size: cover;
  overflow: hidden;
  padding-top: ${({ theme }) =>
    `calc(${theme.space.NAVBAR_HEIGHT}px + ${theme.space.APP_TOP_OFFSET}px)`};
`;

export default BackgroundImage;
